import type { JSX } from 'react'
import type { SettingsSite } from './site'

/** The domain as a badge with one site, a select with more. Nothing otherwise. */
export function SiteChip({ site }: { site: SettingsSite }): JSX.Element | null {
  if (site.status !== 'ready' || site.site === null) return null
  if (site.sites.length === 1) {
    return <span className="ar-badge ar-badge--neutral">{site.site.domain}</span>
  }
  return (
    <select
      className="ar-select app-page-select"
      aria-label="Which site"
      value={site.site.id}
      onChange={(event) => {
        site.select(event.target.value)
      }}
    >
      {site.sites.map((row) => (
        <option key={row.id} value={row.id}>
          {row.domain}
        </option>
      ))}
    </select>
  )
}
